import React from 'react'

import intlxLogo from '../assets/images/intelllex-reversed-logo.png'
import facebookIcon from '../assets/icons/facebook.svg'
import twitterIcon from '../assets/icons/twitter.svg'
import linkedinIcon from '../assets/icons/linkedin.svg'

const Footer = () => (
  <footer>
    <div className="footer__flex-box">
      <div className="footer__logo">
        <img src={intlxLogo} />
      </div>
      <div className="footer__content">
        <div className="row">
          <div className="col-12 col-md">
            <div><a className="link" href="https://intelllex.com/">Products & Services</a></div>
            <div><a className="link" href="https://intelllex.com/company">Meet the team</a></div>
          </div>
          <div className="col-12 col-md">
            <div className="text-block">
              <div className="title-text">Contact Us</div>
              <div>For support issues: <a href="mailto:support@intelllex.com">support@intelllex.com</a></div>
              <div>Contact sales: <a href="mailto:contact@intelllex.com">contact@intelllex.com</a></div>
            </div>
            <div className="text-block">
              <div>276A South Bridge Rd,</div>
              <div>Singapore 058825</div>
            </div>
          </div>
          <div className="col-12 col-md">
            <div className="text-block">
              <div className="title-text">Connect with us</div>
              <a href="https://www.facebook.com/intelllex/" target="_blank" className="social-icon-link">
                <img className="social-icon" src={facebookIcon} />
              </a>
              <a href="https://sg.linkedin.com/company/intelllex" target="_blank" className="social-icon-link">
                <img className="social-icon" src={linkedinIcon} />
              </a>
              <a href="https://twitter.com/intelllexhq" target="_blank" className="social-icon-link">
                <img className="social-icon" src={twitterIcon} />
              </a>
            </div>
          </div>
        </div>
        <div>
          <span className="ie-brand">&copy; INTELLLEX</span>
          &nbsp;&nbsp;
          <a href="https://intelllex.com/privacy" target="_blank">Privacy</a>&nbsp;&nbsp;|&nbsp;&nbsp;
          <a href="https://intelllex.com/terms" target="_blank">Terms</a>

        </div>
      </div>
      <div className="footer__logo" />
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js